import { render, staticRenderFns } from "./DetailOrdersPrepaid.vue?vue&type=template&id=4270ec20&"
import script from "./DetailOrdersPrepaid.vue?vue&type=script&lang=js&"
export * from "./DetailOrdersPrepaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports